import styled from 'styled-components';

export const ThumbnailWrapper = styled.div`
  display: flex;
  width: 230px;
  flex-direction: column;
  margin-left: 20px;
  margin-bottom: 20px;
`;

export const ThumbnailBox = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url(${(props) => props.url});
  background-size: cover;
`;

export const ThumbnailBoxButtonText = styled.div`
  text-transform: uppercase;
  color: #FFFFFF;
  font-size: 12px;
  font-weight: bold;
  font-family: inherit;
  letter-spacing: 1px;
  line-height: 14px;
`;

export const ThumbnailBoxBorder = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  height: 150px;

  transition: all 0.3s ease;
  box-shadow: ${(props) => props.hovered ?
    '0 8px 10px 0 rgba(0,0,0,0.18), 0 6px 22px 5px rgba(0,0,0,0.16), 0 15px 44px 0 rgba(0,0,0,0.08)' :
    '0 1px 3px 0 rgba(0,0,0,0.08), 0 4px 6px 0 rgba(50,50,93,0.11)'};
`;

export const ThumbnailTitle = styled.div`
  margin-top: 10px;
  color: ${(props) => props.theme['color.text.title']};

  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
`;

export const ThumbnailDescription = styled.div`
  margin-top: 5px;

  color: ${(props) => props.theme['color.text.body']};
  font-family: inherit;
  font-size: 14px;
  line-height: 18px;
`;

export const ThumbnailBoxOverlay = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(24,33,45,0.8);

  & > :not(:first-child) {
    margin-top: 10px;
  }
`;
